import axios from "axios";

import { getHeader } from "../headers";

// ===================================================================================
//  GET NEWS
// ===================================================================================
export const newsItemIsLoading = () => {
	return {
		type: "NEWS_ITEM_IS_LOADING"
	};
};

export const newsItemHasError = err => {
	return {
		type: "NEWS_ITEM_HAS_ERROR",
		hasErrored: true,
		error: err
	};
};

export const newsItemSuccess = data => {
	return {
		type: "NEWS_ITEM_SUCCESS",
		data
	};
};

export function getNewsItemByPermalink(permalink) {
	return dispatch => {
		dispatch(newsItemIsLoading());

		// Add id of record to find if passed
		const endPoint = `news/permalink?permalink=${permalink}`;

		const params = {
			language: process.env.REACT_APP_LANGUAGE
		};

		return axios
			.get(process.env.REACT_APP_API_URL + endPoint, {
				headers: getHeader(),
				params
			})
			.then(response => {
				if (response.data.status && response.data.status !== 200) {
					dispatch(newsItemHasError(response.data.errors));
				} else {
					return dispatch(newsItemSuccess(response));
				}
			})
			.catch(err => {
				dispatch(newsItemHasError(err.response.data.message));
			});
	};
}

// ===================================================================================
//  CLEAR
// ===================================================================================
export const clearNewsItem = () => {
	return {
		type: "NEWS_ITEM_CLEAR"
	};
};



// WEBPACK FOOTER //
// ./src/store/actions/newsItem.js